import type {AgentFinderEntry} from '../../../../types'

import {GridCard} from '../GridCard/GridCard'

import styles from './GridSection.module.css'

type Props = {
  entries: AgentFinderEntry[]
}

export function GridSection(props: Props) {
  const {entries} = props

  return (
    <section className={styles.grid}>
      {entries.map(entry => (
        <GridCard key={entry.identifier} entry={entry} />
      ))}
    </section>
  )
}
